import Crud from '../views/RespostaRapida/Crud'
import Entity from '../views/RespostaRapida/Add'

let routes = {
    path: '/respostas_rapidas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/respostas_rapidas/add',
            name: 'NewRespostaRapida',
            component: Entity
        },
        {
            path: '/respostas_rapidas/edit/:id?',
            name: 'EditRespostaRapida',
            component: Entity
        },
        {
            path: '/respostas_rapidas',
            name: 'list-respostas_rapidas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Respostas Rápidas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
